import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Container,
  Row,
  Col,
  InputGroup,
  FormControl,
  Table,
  DropdownButton,
  Dropdown,
  Accordion,
  Form,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
// import SuperUserModal from "../../components/Modals/SuperUserModel";
import ExportModal from "../../components/Modals/ExportsModel/main";
import ImportModal from "../../components/Modals/ImportModel";
import NoData from "../../components/NoData";
import Loader from "../../components/Loader";
import {
  MdArrowBackIos,
  MdArrowForwardIos,
  MdCancel,
  MdCheckCircle,
} from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  FaEdit,
  FaFileExport,
  FaFileImport,
  FaPlus,
  FaTrashAlt,
  FaUserCircle,
} from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { useCommonContext } from "../../utils/context";
import AgentModal from "../../components/Modals/AgentModel";
import CommonButton from "../../components/CommonButton";
import Pagination from "../../components/Pagination";
import ViewModal from "../../components/Modals/HisstoryModals/UserViewModel";

const SuperUser = () => {
  const [showSuperUserModal, setShowSuperUserModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [superUsers, setSuperUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editSuperUserData, setEditSuperUserData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedSuperUsers, setSelectedSuperUsers] = useState([]);

  const [itemOffset, setItemOffset] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);
  const role = localStorage.getItem("role");
  const { toggled } = useCommonContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = superUsers;
  const pageCount = Math.ceil(superUsers.length / itemsPerPage);
  const [statusFilter, setStatusFilter] = useState(true);
  const [showViewModal, setShowViewModal] = useState(false);

  useEffect(() => {
    fetchSuperUsers(currentPage);
  }, [currentPage, itemsPerPage, searchText, statusFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  const fetchSuperUsers = async (page = 1) => {
    setLoading(true);
    try {
      let url = `${BASE_URL}/users/tms_users/`;
      if (statusFilter === false) {
        url = `${BASE_URL}/users/tms_users/deactivate-users/`;
      }

      const response = await axios.get(url, {
        headers: HEADERS,
        params: {
          role: "superuser",
          page: page,
          page_size: itemsPerPage,
          search: searchText || undefined,
          ...(statusFilter !== false && {
            is_active: statusFilter !== null ? statusFilter : undefined,
          }),
        },
      });

      if (response.data?.results) {
        setSuperUsers(response.data.results || []);
        setTotalPages(response.data.total_pages);
        setCurrentPage(page);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchSuperUsers(1);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEditSuperUser = (superUser) => {
    setEditSuperUserData(superUser);
    setShowSuperUserModal(true);
  };

  const handleDeleteSuperUser = async (superUserId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/users/tms_users/${superUserId}/`,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response) {
        toast.success("Manager deleted successfully!");
        fetchSuperUsers(currentPage);
      } else {
        toast.error("Failed to delete Manager. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleToggleActive = async (superUserId, currentStatus) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${superUserId}/`,
        { is_active: !currentStatus },
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
        },
      );
      if (response) {
        toast.success(
          `Manager ${currentStatus ? "deactivated" : "activated"} successfully!`,
        );
        fetchSuperUsers(currentPage);
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleCloseModals = () => {
    setShowSuperUserModal(false);
    setShowImportModal(false);
    setEditSuperUserData(null);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const handleViewUser = (superUser) => {
    setSelectedSuperUsers(superUser);
    setShowViewModal(true);
  };

  const handleAddUser = () => {
    setEditSuperUserData(null);
    setShowSuperUserModal(true);
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 d-flex container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-2 mb-md-0">Manager</h4>
        <div className="d-none d-md-flex align-items-center gap-2">
          <Form.Control
            type="text"
            placeholder="Search Here..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="uniform-input search-text"
          />

          <Form.Select
            value={
              statusFilter === true
                ? "is_active"
                : statusFilter === false
                  ? "!is_active"
                  : ""
            }
            onChange={(e) => {
              const value = e.target.value;
              if (value === "is_active") {
                setStatusFilter(true);
              } else if (value === "!is_active") {
                setStatusFilter(false);
              } else {
                setStatusFilter(null);
              }
            }}
            className="uniform-input"
          >
            <option value="is_active">Active</option>
            <option value="!is_active">Inactive</option>
          </Form.Select>

          <CommonButton className="uniform-button" onClick={handleAddUser}>
            <FaPlus className="me-1" /> Add
          </CommonButton>

          <CommonButton
            className="uniform-button"
            onClick={() => setShowImportModal(true)}
          >
            <FaFileImport className="me-1" /> Import
          </CommonButton>

          <CommonButton
            className="uniform-button"
            onClick={() => setShowExportModal(true)}
            disabled={currentItems.length === 0}
          >
            <FaFileExport className="me-1" />{" "}
            {exportLoading ? "Exporting..." : "Export"}
          </CommonButton>
        </div>
        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body className="pt-3">
                <Form.Control
                  type="text"
                  placeholder="Search Here..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="uniform-input search-text mb-3"
                />

                <Form.Select
                  value={
                    statusFilter === true
                      ? "is_active"
                      : statusFilter === false
                        ? "!is_active"
                        : ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "is_active") {
                      setStatusFilter(true);
                    } else if (value === "!is_active") {
                      setStatusFilter(false);
                    } else {
                      setStatusFilter(null);
                    }
                  }}
                  className="uniform-input mb-3"
                >
                  <option value="is_active">Active</option>
                  <option value="!is_active">Inactive</option>
                </Form.Select>
                <div className="row g-2 mt-2">
                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={handleAddUser}
                    >
                      <FaPlus className="me-1" /> Add
                    </CommonButton>
                  </div>

                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={() => setShowImportModal(true)}
                    >
                      <FaFileImport className="me-1" /> Import
                    </CommonButton>
                  </div>

                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={() => setShowExportModal(true)}
                      disabled={currentItems.length === 0}
                    >
                      <FaFileExport className="me-1" />{" "}
                      {exportLoading ? "Exporting..." : "Export"}
                    </CommonButton>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${currentItems.length === 0 ? "" : "tabell"} `}
      >
        {loading ? (
          <Loader />
        ) : (
          <>
            {currentItems.length > 0 ? (
              <table className="table   tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th style={{ width: "350px" }}>Name</th>
                    <th style={{ width: "250px" }}>Email</th>
                    <th style={{ width: "250px" }}>Phone</th>
                    <th style={{ width: "200px" }}>Date of Joining</th>
                    <th style={{ width: "200px" }}>Casual Leaves</th>
                    <th style={{ width: "200px" }}>Sick Leaves</th>
                    <th style={{ width: "200px" }}>Punch-In Time</th>
                    <th style={{ width: "200px" }}>Punch-Out Time</th>
                    <th style={{ width: "150px" }}>Status</th>
                    <th style={{ width: "150px" }}>Latitude</th>
                    <th style={{ width: "150px" }}>Longitude</th>
                    <th style={{ width: "150px" }}>GPS Status</th>
                    <th style={{ width: "150px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((superUser, index) => (
                    <tr
                      key={superUser.id}
                      onClick={() => handleViewUser(superUser)}
                      className="tbody"
                      style={{
                        background: index % 2 === 0 ? "#f2f2f2" : "#fff",
                      }}
                    >
                      <td>
                        <div className="d-flex align-items-center ">
                          <span className="badge bg-primary text-white me-2 emp-id-badge">
                            {superUser.emp_id || "—"}
                          </span>
                          {superUser.profile_image ? (
                            <img
                              src={superUser.profile_image}
                              alt="Profile"
                              className="rounded-circle border me-2"
                              style={{ width: "30px", height: "30px" }}
                            />
                          ) : (
                            <FaUserCircle
                              size={30}
                              className="text-primary me-2"
                            />
                          )}
                          <div
                            title={superUser.first_name || "—"}
                            className="tdsubject"
                          >
                            {superUser.first_name} {superUser.last_name}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div
                          title={superUser.email || "—"}
                          className="tdsubject"
                        >
                          {superUser.email || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={superUser.phone_number || "—"}
                          className="tdsubject"
                        >
                          {superUser.phone_number || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={superUser.date_joined || "—"}
                          className="tdsubject"
                        >
                          {superUser.date_joined || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={superUser.allocated_casual_leave || "—"}
                          className="tdsubject"
                        >
                          {superUser.allocated_casual_leave || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={superUser.allocated_sick_leave || "—"}
                          className="tdsubject"
                        >
                          {superUser.allocated_sick_leave || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            superUser.today_attendance?.punch_in
                              ? formatTime(superUser.today_attendance?.punch_in)
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {superUser.today_attendance?.punch_in
                            ? formatTime(superUser.today_attendance?.punch_in)
                            : "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            superUser.today_attendance?.punch_out
                              ? formatTime(
                                  superUser.today_attendance?.punch_out,
                                )
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {superUser.today_attendance?.punch_out
                            ? formatTime(superUser.today_attendance?.punch_out)
                            : "—"}
                        </div>
                      </td>

                      <td>
                        {superUser.today_attendance?.status || "NA"}
                        <br />
                        <span
                          className={`badge ${
                            superUser.is_active ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {superUser.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>
                        <td>
                        <div
                          title={
                            superUser.longitude
                              ? `${superUser.longitude}`
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {superUser.longitude
                            ? `${superUser.longitude}`
                            : "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            superUser.latitude ? `${superUser.latitude}` : "—"
                          }
                          className="tdsubject"
                        >
                          {superUser.latitude ? `${superUser.latitude}` : "—"}
                        </div>
                      </td>
                      <td>{superUser.gps_status ? "On" : "Off"}</td>

                      <td>
                        <div className="ms-auto">
                          <DropdownButton
                            id="dropdown-basic-button"
                            title={<BsThreeDotsVertical />}
                            variant="link"
                            className="p-0 text-secondary custom-dropdown"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Dropdown.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditSuperUser(superUser);
                              }}
                            >
                              <FaEdit className="me-2" /> Edit
                            </Dropdown.Item>
                            {role === "admin" && (
                              <Dropdown.Item
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteSuperUser(superUser.id);
                                }}
                              >
                                <FaTrashAlt className="me-2" /> Delete
                              </Dropdown.Item>
                            )}
                            <Dropdown.Item
                              as="button"
                              onClick={() =>
                                handleToggleActive(
                                  superUser.id,
                                  superUser.is_active,
                                )
                              }
                            >
                              {superUser.is_active ? (
                                <>
                                  <MdCancel className="me-2" /> Deactivate
                                </>
                              ) : (
                                <>
                                  <MdCheckCircle className="me-2" /> Activate
                                </>
                              )}
                            </Dropdown.Item>
                          </DropdownButton>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </>
        )}
      </div>

      {currentItems.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {showSuperUserModal && (
        <AgentModal
          show={showSuperUserModal}
          handleClose={handleCloseModals}
          agentData={editSuperUserData}
          roletype="superuser"
          fetchAgents={() => fetchSuperUsers(currentPage)}
        />
      )}

      <ViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        userId={selectedSuperUsers?.id}
        user={selectedSuperUsers}
      />

      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="superusers"
      />

      {showImportModal && (
        <ImportModal
          show={showImportModal}
          handleClose={handleCloseModals}
          type="superusers"
          onSuccess={() => fetchSuperUsers(currentPage)}
        />
      )}
    </div>
  );
};

export default SuperUser;
